// src/lib/categories.ts

export const categories = [
  { name: 'Prop Firm Reviews', slug: 'reviews' },
  { name: 'Trading Tips', slug: 'trading-tips' },
  { name: 'Challenges & Strategy', slug: 'challenges' },
  { name: 'News & Updates', slug: 'news' },
  { name: 'Guides', slug: 'guides' }
];

export const categoryMap = Object.fromEntries(
  categories.map((cat) => [cat.slug, cat.name])
);